import {AxiosClient as axios, genericServiceImpl} from '../../../services/index';

export const PeriodService = genericServiceImpl('reporting-periods', 'gas');

export const GrantDetailService = {
    ...genericServiceImpl('grant-details', 'gas'),
    search: () => {
        return axios.get('/api/gas/grant-details/results?searchTerm=&offset=0&pageSize=0' );
    },
    getNotInPeriod: (periodId) => {
        return axios.get('/api/gas/grant-details/not-in-period/' + periodId)
    },
    validateContacts: (grantId) => {
        return axios.put('/api/gas/grant-details/approve-emails/' + grantId, {});
    },
};

export const GrantAccountStatementService = {
    ...genericServiceImpl('grant-account-statements', 'gas'),
    getByPeriodId: (periodId) => {
        return axios.get(`/api/gas/grant-account-statements/results?pageSize=0&reportingPeriodId=${periodId}`)
    },
    send: (gasId) => {
        return axios.get('/api/gas/grant-account-statements/send/' + gasId);
    },
    checkHasValidFile: (gasId) => {
        return axios.get('/api/gas/grant-account-statements/valid-gas-file/' + gasId);
    },
    setFile: (gasId, obj) => {
        return axios.put('/api/gas/grant-account-statements/set-file/' + gasId, obj);
    },
    approveEmails: (gasId) => {
        return axios.put('/api/gas/grant-account-statements/approve-emails/' + gasId, {});
    },
    relinkGasFiles: (gasId) => {
        return axios.get('/api/gas/grant-account-statements/reporting-period/' + gasId + '/validate-gas-files', {});
    },
    addMultipleGrants: (periodId, grantIds) => {
        return axios.post('/api/gas/grant-account-statements/add-grants-to-period/' + periodId , grantIds);
    }
}

export const EmailContentService = {
    ...genericServiceImpl('email-content', 'gas'),
    getForGas: (gasId) => {
        return axios.get('/api/gas/email-content/for-gas/' + gasId)
    }
}

export const OneWamboPerformanceStatus = {
    ...genericServiceImpl('status', 'wambo')
}

export const OneCpPerformanceStatus = {
    ...genericServiceImpl('status', 'onecp')
}



export const PrincipalRecipientsService = genericServiceImpl('principal-recipients', 'gas');


export const EmailTemplateService = genericServiceImpl('email-templates', 'gas');

export const LanguageService = genericServiceImpl('languages', 'gas');


export const GasCountryService = {
    ...genericServiceImpl('countries', 'gas'),
    search: () => {
        return axios.get('/api/gas/countries/results?searchTerm=&offset=0&pageSize=0');
    },
    mergeCountry: (mainId, alternativeId) => {
        return axios.put('/api/gas/countries/merge/' + mainId + '/' + alternativeId);
    }
}

export const ReportingGroupService = genericServiceImpl('reporting-groups', 'gas');